import React from 'react';
import { SubHeading, MenuItem } from '../../components';
import { images, data } from '../../constants';
import './SpecialMenu.css';

const SpecialMenu = () => (
  <div className='app__specialMenu flex__center section__padding'>
    <div className='app__specialMenu-title' id='menu'>
      <SubHeading title='Sushi para deleitar tu paladar'/>
      <h1 className='headtext__cormorant'>Nuestra carta</h1>
    </div>

    <div className='app__specialMenu-menu'>
      <div className='app__specialMenu-menu_wine flex__center'>
        <p className='app__specialMenu-menu_heading'>Rolls</p>
        <div className='app__specialMenu_menu_items'>
          {data.rolls.map((rolls, index) =>(
            <MenuItem key={rolls.title + index} title={rolls.title} price={rolls.price} tags={rolls.tags}/>
          ))}

        </div>
      </div>

      <div className='app__specialMenu-menu_img'>
        <img src={images.menu} alt="menu img" />
      </div>

      <div className='app__specialMenu-menu_cocktails flex__center'>
        <p className='app__specialMenu-menu_heading'>Promociones</p>
        <div className='app__specialMenu_menu_items' style={{ marginTop: '2rem' }}>
          {data.promos.map((promos, index) =>(
            <MenuItem key={promos.title + index} title={promos.title} price={promos.price} tags={promos.tags}/>
          ))}

        </div>
      </div>

    </div>

  </div>
);

export default SpecialMenu;
